import Accordion from './Accordion';
import './styles.scss';

export default Accordion;
